'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventDescription = function EventDescription(_ref) {
  var description = _ref.description;

  if (description) {
    return _react2.default.createElement('div', { className: 'EventDescription', dangerouslySetInnerHTML: { __html: description } });
  }
  return null;
};

EventDescription.propTypes = {
  /** The HTML description. */
  description: _propTypes2.default.string
};

EventDescription.defaultProps = {
  description: null
};

exports.default = EventDescription;
EventDescription.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'EventDescription',
  'props': {
    'description': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The HTML description.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventDescription.js
// module id = 182
// module chunks = 0